'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 400px;\n'], ['\n  max-width: 400px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: red;\n'], ['\n  color: red;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _buttonGroup = require('../button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _modal = require('../modal/modal');

var _modal2 = _interopRequireDefault(_modal);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Alert = _styledComponents2.default.div(_templateObject2);

/** @class Modal
  * A component for displaying a Modal
  * @prop {HTMLString} children - the DOM elements to show in the modal
  * @prop {boolean} show - if the modal should be shown
  * @prop {function} onExit - the exit event handler for the modal.
  */

var AnonymousConfirmation = function (_Component) {
  _inherits(AnonymousConfirmation, _Component);

  /** @constructor
    * Creates a new instance of AnonymousConfirmation
    */
  function AnonymousConfirmation(props) {
    _classCallCheck(this, AnonymousConfirmation);

    var _this = _possibleConstructorReturn(this, (AnonymousConfirmation.__proto__ || Object.getPrototypeOf(AnonymousConfirmation)).call(this, props));

    _this.state = { alert: '' };
    _this.handleAnonymousSignin = _this.handleAnonymousSignin.bind(_this);
    return _this;
  }
  /** @method handleAnonymousSignin
    * Signs the user in anonymously.
    */


  _createClass(AnonymousConfirmation, [{
    key: 'handleAnonymousSignin',
    value: function handleAnonymousSignin() {
      var _this2 = this;

      window.vexpo.firebase.auth().signInAnonymously().catch(function (error) {
        _this2.setState({ alert: error.message });
      });
    }
    /** @method render
      * Renders the modal
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _modal2.default,
        { show: this.props.show, onExit: this.props.onExit },
        _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Are you sure don\'t want to register?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Registering enters you in the door prize drawings and allows you to save your showbag contents, including exclusive discounts from exhibitors.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'The show does not share login information with any business, show exhibitor, or third party.  We do not send you ads.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'See our ',
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/privacy' },
              'Privacy Policy'
            ),
            ' and ',
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/tos' },
              'Terms of Service'
            ),
            ' for details.'
          ),
          _react2.default.createElement(
            _buttonGroup2.default,
            null,
            _react2.default.createElement(
              'button',
              { onClick: this.handleAnonymousSignin },
              'No thanks, proceed to show without registering'
            )
          ),
          _react2.default.createElement(
            _buttonGroup2.default,
            null,
            _react2.default.createElement(
              'button',
              { onClick: this.props.onExit },
              'Yes!  Please take me back to the registration options'
            )
          ),
          _react2.default.createElement(
            Alert,
            null,
            this.state.alert
          )
        )
      );
    }
  }]);

  return AnonymousConfirmation;
}(_react.Component);

exports.default = AnonymousConfirmation;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/anonymous/anonymous-confirmation.js
// module id = 898
// module chunks = 0